import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from './../../guards/auth.guard'
import { MainComponent } from './../main/main.component'
import { GlobalNavigationBarComponent } from './global-navigation-bar.component'

const routes: Routes = [
  {
    path: '',
    component: GlobalNavigationBarComponent,
    children: [
      { path: '', redirectTo: '/gnb/main', pathMatch: 'full' },
      {
        path: 'main',
        component: MainComponent,
      },
      {
        path: 'friends',
        loadChildren: () => import('../../pages/friends/friends.module').then((m) => m.FriendsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'profile',
        loadChildren: () => import('../../pages/my/my.module').then((m) => m.MyModule),
        canActivate: [AuthGuard],
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
  // providers: [
  //   {
  //     provide: ROUTES,
  //     useFactory: (localeService: LocaleService) => {
  //       if (localeService.locale === LocaleCode.ko) return routes
  //       // 한국어 외의 경우에만 MainEnComponent 변경
  //       routes.forEach((route) => {
  //         route.children?.forEach((child) => {
  //           if (child.path === 'main') {
  //             child.component = MainEnComponent
  //           }
  //         })
  //       })
  //       return routes
  //     },
  //     multi: true,
  //     deps: [LocaleService],
  //   },
  // ],
})
export class GlobalNavigationBarRoutingModule {}
